import React from 'react';
import TextField from '@material-ui/core/TextField';
import { Button } from 'semantic-ui-react';
import $ from "jquery";

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import Server from '../../../functions/server';
import getFormatedDate from '../../../functions/date';

export default class App extends React.Component {

  state = {
    fromDate: getFormatedDate(new Date()),
    toDate: getFormatedDate(new Date()),
    report: [], taxArray: []
  }

  getHsnReport = () => {
      let context = this;
      context.setState({ load: true, message: 'Getting Branchs' });
        $.ajax({
        type: 'POST', data: { 'from_date': context.state.fromDate, 'to_date': context.state.toDate },
        url: Server() + 'Accountings/GSTSalesReport/GetHsnCodeBaseReport.php',
        success: function(data) {
            console.log(data);
            try {
                data = JSON.parse(data);
                context.removeDuplicate(data);
                context.setState({ load: false, report: data, dialog: true });
            } catch (e) {
                alert('Error')
                context.setState({ load: false });
            }
        },
        error: function(e) {
            alert('Try again!!')
            context.setState({ load: false });
        }
        });
  }

  removeDuplicate = (data) => {
    let context = this;
    let taxArray = data.filter((v,i,a)=>a.findIndex(t=>(t.tax===v.tax && t.tax != ''))===i);
    taxArray.map((c) => {
        let newArray = [];
        data.map((v) => {
            if (c.tax == v.tax) {
                newArray.push(v)
            }
        })
        c.report = JSON.stringify(newArray);
    })
    context.setState({ taxArray })
  }

  convertIntoNumber = (value) => {
      try {
        value = Number(value);
      } catch (error) {
        value = 0;
      }
      return value;
  }

  makeDecimalPoints = (value) => {
      try {
        value = value.toFixed(2);
      } catch (error) {
        value = 0;
      }
      return value;
  }

  render() {
    let { dialog, taxArray } = this.state;
    let totalqty = 0;
    let totaltaxableamount = 0;
    let otherChargeAmount = 0;
    let totalamount = 0;
    let IGST = 0;
    let SGST = 0;
    return (
      <div>
        <Button onClick={this.getHsnReport}>HSNCode Based Report</Button>
        <Dialog fullWidth={true}  maxWidth={'lg'}
            open={dialog} onClose={ () => { this.setState({ dialog: false }) }} 
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">HSNCODE BASED REPORT</DialogTitle>
            <DialogContent>
                <div style={{float: 'left', display: 'flex'}}>
                    <TextField label="From" type="date"
                    onChange={(e) => this.setState({fromDate: e.target.value})}
                    defaultValue={this.state.fromDate} />
                    <TextField style={{marginLeft: 20}} label="To" type="date"
                    onChange={(e) => this.setState({toDate: e.target.value})}
                    defaultValue={this.state.toDate} />
                    <Button variant="contained" color="primary" style={{marginLeft:20, marginTop: '1%'}} 
                    onClick={this.getHsnReport}>Go</Button>
                </div>
                <br/><br/>
                { 
                    taxArray.map((c) => {
                        let array = [];
                        try {
                            array = JSON.parse(c.report);
                        } catch (error) {
                        }

                        let sqty = 0;
                        let staxable = 0;
                        let scgstandsgst = 0;
                        let sigst = 0;
                        return (
                            <div style={{marginTop: '2%'}}>
                                <h3 style={{display: !c.hsncode ? 'none' : 'show'}}>{'GST'+c.tax+"%"}</h3>
                                <table width="100%" id="table" style={{display: !c.hsncode ? 'none' : 'show'}}>
                                    <tr >
                                        <th id="th" style={{width: '15%'}}>HSN</th>
                                        <th id="th" style={{width: '10%'}}>QTY</th>
                                        <th id="th" style={{width: '12%'}}>Taxable Value</th>
                                        <th id="th" style={{width: '12%'}}>IGST</th>
                                        <th id="th" style={{width: '12%'}}>CGST</th>
                                        <th id="th" style={{width: '12%'}}>SGST</th>
                                        <th id="th" style={{width: '12%'}}>Other Charge</th>
                                        <th id="th" style={{width: '15%'}}>Total Value</th>
                                    </tr>
                                    {
                                        array.map((v) => {
                                            let tax = this.convertIntoNumber(v.tax);
                                            let qty = this.convertIntoNumber(v.qty);
                                            totalqty = totalqty + qty;
                                            sqty = sqty + qty;
                                            
                                            let total = this.convertIntoNumber(v.total);
                                            let taxs = 0;
                                            if (tax < 10) {
                                                taxs = '1.0'+tax;
                                            }
                                            else {
                                                taxs = '1.'+tax;
                                            }
                                            taxs = this.convertIntoNumber(taxs);
                                            let taxablePrice = total/taxs;
                                            totaltaxableamount = totaltaxableamount + taxablePrice;
                                            totalamount = totalamount + total;
                                            if (v.deliverystate == v.state) {
                                                SGST = SGST + (total - taxablePrice);
                                            }
                                            else {
                                                IGST = IGST + (total - taxablePrice);
                                            }
                                            if (!v.hsncode) {
                                                otherChargeAmount = otherChargeAmount + total;
                                                return null;
                                            }
                                            staxable = staxable + taxablePrice;

                                            if (v.deliverystate == v.state) {
                                                scgstandsgst = scgstandsgst + ((total - taxablePrice)/2);
                                            }
                                            else {
                                                
                                                sigst = sigst + (total - taxablePrice);
                                            }
                                            
                                            return (
                                                <tr>
                                                    <td>{v.hsncode}</td>
                                                    <td>{v.qty}</td>
                                                    <td style={{textAlign: 'right'}}>{this.makeDecimalPoints(taxablePrice)}</td>
                                                    <td style={{textAlign: 'right'}}>{v.deliverystate == v.state ? '' : this.makeDecimalPoints(total - taxablePrice)}</td>
                                                    <td style={{textAlign: 'right'}}>{v.deliverystate == v.state ? this.makeDecimalPoints(((total - taxablePrice)/2)) : ''}</td>
                                                    <td style={{textAlign: 'right'}}>{v.deliverystate == v.state ? this.makeDecimalPoints(((total - taxablePrice)/2)) : ''}</td>
                                                    <td></td>
                                                    <td style={{textAlign: 'right'}}>{this.makeDecimalPoints(total)}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                    <tr>
                                        <td style={{width: '15%'}}><b>{'Total'}</b></td>
                                        <td style={{width: '10%', fontWeight: 'bold'}}>{sqty}</td>
                                        <td style={{textAlign: 'right', width: '12%', fontWeight: 'bold'}}>{this.makeDecimalPoints(staxable)}</td>
                                        <td style={{textAlign: 'right', width: '12%', fontWeight: 'bold'}}>{this.makeDecimalPoints(sigst)}</td>
                                        <td style={{textAlign: 'right', width: '12%', fontWeight: 'bold'}}>{this.makeDecimalPoints(scgstandsgst)}</td>
                                        <td style={{textAlign: 'right', width: '12%', fontWeight: 'bold'}}>{this.makeDecimalPoints(scgstandsgst)}</td>
                                        <td style={{textAlign: 'right', width: '12%', fontWeight: 'bold'}}>{this.makeDecimalPoints(0)}</td>
                                        <td style={{textAlign: 'right', width: '15%', fontWeight: 'bold'}}>{this.makeDecimalPoints(staxable + sigst + scgstandsgst + scgstandsgst)}</td>
                                    </tr>
                                </table>
                            </div>
                        )

                    })
                }
                <table width="100%" id="table"  style={{marginTop: '2%'}}>
                    <tr>
                        <td style={{width: '15%'}}><b>{'Total'}</b></td>
                        <td style={{width: '10%', fontWeight: 'bold'}}>{totalqty}</td>
                        <td style={{textAlign: 'right', width: '12%', fontWeight: 'bold'}}>{this.makeDecimalPoints(totaltaxableamount)}</td>
                        <td style={{textAlign: 'right', width: '12%', fontWeight: 'bold'}}>{this.makeDecimalPoints(IGST)}</td>
                        <td style={{textAlign: 'right', width: '12%', fontWeight: 'bold'}}>{this.makeDecimalPoints(SGST/2)}</td>
                        <td style={{textAlign: 'right', width: '12%', fontWeight: 'bold'}}>{this.makeDecimalPoints(SGST/2)}</td>
                        <td style={{textAlign: 'right', width: '12%', fontWeight: 'bold'}}>{this.makeDecimalPoints(otherChargeAmount)}</td>
                        <td style={{textAlign: 'right', width: '15%', fontWeight: 'bold'}}>{this.makeDecimalPoints(totalamount + otherChargeAmount)}</td>
                    </tr>
                </table>
                
            </DialogContent>
            <DialogActions>
                <Button onClick={ () => { this.setState({ dialog: false }) }}>Close</Button>
            </DialogActions>
        </Dialog>
      </div>
    );
  }
}